import {AfterViewInit, Component, HostListener, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RouterEvent} from '@angular/router';
import $ from 'jquery';
import {Meta, Title} from '@angular/platform-browser';
import {AppService} from './services/app.service';
import {GoogleTagManagerService} from 'angular-google-tag-manager';
import {interval} from 'rxjs';
import {UpdateService} from './services/update.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, AfterViewInit {
  title = 't2d-app';
  public showOverlay = true;

  constructor(
    private router: Router,
    private meta: Meta,
    private titleService: Title,
    private activatedroute: ActivatedRoute,
    private appService: AppService,
    private gtmService: GoogleTagManagerService,
    private swUpdate: UpdateService
  ) {
    this.router.events.subscribe((event: RouterEvent) => {
      this.navigationInterceptor(event);
    });
    this.activatedroute.queryParams.subscribe((params) => {
      this.appService.setUTMTrackingStorage(params);
    });

    // this.swUpdate.checkForUpdates();
  }

  ngAfterViewInit(): void {

  }

  // Shows and hides the loading spinner during RouterEvent changes
  navigationInterceptor(event: RouterEvent): void {
    if (event instanceof NavigationStart) {
      this.showOverlay = true;
    }
    if (event instanceof NavigationEnd) {
      this.showOverlay = false;
      console.log('I am called');
      const gtmTag = {
        event: 'page',
        pageName: event.url
      };

      this.gtmService.pushTag(gtmTag);
    }

    // Set loading state to false in both of the below events to hide the spinner in case a request fails
    if (event instanceof NavigationCancel) {
      this.showOverlay = false;
    }
    if (event instanceof NavigationError) {
      this.showOverlay = false;
    }
  }


  ngOnInit(): void {
// page metas
    this.meta.addTag({name: 'description', content: ''});
    this.meta.addTag({name: 'copyright', content: 'Things2do'});
    this.meta.addTag({name: 'robots', content: 'index,follow'});
    this.titleService.setTitle('Things2do');

    // meta tags
    this.meta.addTag({property: 'og:url', content: ''});
    this.meta.addTag({property: 'og:title', content: ''});
    this.meta.addTag({property: 'og:description', content: ''});
    this.meta.addTag({property: 'og:image', content: ''});

    // twitter cards
    this.meta.addTag({property: 'twitter:card', content: 'summary'});
    this.meta.addTag({property: 'twitter:site', content: '@things2do'});
    this.meta.addTag({property: 'twitter:title', content: ''});
    this.meta.addTag({property: 'twitter:description', content: ''});
    this.meta.addTag({property: 'twitter:image', content: ''});
  }

  switchCity(cityName): void {
    localStorage.setItem('currentCity', cityName);
  }

  doLogout(): void {
    localStorage.clear();
    this.router.navigate(['/login']);
  }

}
